import { supabase } from '../../lib/supabase';

export interface NotifyEventParams {
  event_type: 'lead' | 'appointment' | 'guest_message' | 'rsvp' | 'job_selection_completed' | string;
  data: Record<string, string | number | boolean | undefined | null>;
}

export interface NotifyEventResponse {
  ok: boolean;
  error?: string;
}

/**
 * Envía una notificación genérica por email al administrador.
 * No requiere sesión de usuario — usa la anon key directamente.
 * La notificación llega a axloweb2018@gmail.com
 */
export async function notifyEvent(
  params: NotifyEventParams,
): Promise<NotifyEventResponse> {
  try {
    const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
    const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

    if (!supabaseUrl || !supabaseAnonKey) {
      console.warn('⚠️ notifyEvent: faltan variables de entorno Supabase');
      return { ok: false, error: 'Configuración incompleta' };
    }

    const url = `${supabaseUrl}/functions/v1/notify_event`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'apikey': supabaseAnonKey,
      },
      body: JSON.stringify(params),
    });

    const responseText = await response.text();
    let result: { ok: boolean; error?: string; code?: string } = { ok: false };

    try {
      result = JSON.parse(responseText);
    } catch {
      return { ok: false, error: responseText || `HTTP ${response.status}` };
    }

    if (!response.ok || !result.ok) {
      const errorMsg = result.error || result.code || `HTTP ${response.status}`;
      console.error('❌ notifyEvent error:', errorMsg);
      return { ok: false, error: errorMsg };
    }

    console.log('✅ Notificación enviada correctamente:', params.event_type);
    return { ok: true };
  } catch (error) {
    const msg = error instanceof Error ? error.message : 'Error desconocido';
    console.error('❌ notifyEvent excepción:', msg);
    return { ok: false, error: msg };
  }
}